module.exports = __webpack_public_path__ + "static/media/linkimg5.93e56e03.jpg";